import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Option } from "./Option.mjs";
import { Struct } from "./Struct.mjs";
import { Tuple } from "./Tuple.mjs";
import { Vec } from "./Vec.mjs";
var EMPTY = new Uint8Array();
/**
 * @name Linkage
 * @description The wrapper for the result from a LinkedMap
 */

export var Linkage =
/*#__PURE__*/
function (_Struct) {
  _inherits(Linkage, _Struct);

  function Linkage(registry, Type, value) {
    _classCallCheck(this, Linkage);

    return _possibleConstructorReturn(this, _getPrototypeOf(Linkage).call(this, registry, {
      previous: Option.with(Type),
      // eslint-disable-next-line sort-keys
      next: Option.with(Type)
    }, value));
  }

  _createClass(Linkage, [{
    key: "toRawType",

    /**
     * @description Returns the base runtime type name for this instance
     */
    value: function toRawType() {
      return "Linkage<".concat(this.next.toRawType(true), ">");
    }
    /**
     * @description Custom toU8a which with bare mode does not return the linkage if empty
     */

  }, {
    key: "toU8a",
    value: function toU8a() {
      // As part of a storage query (where these appear), in the case of empty, the values
      // are NOT populated by the node - follow the same logic, leaving it empty
      return this.isEmpty ? EMPTY : _get(_getPrototypeOf(Linkage.prototype), "toU8a", this).call(this);
    }
  }, {
    key: "previous",
    get: function get() {
      return this.get('previous');
    }
  }, {
    key: "next",
    get: function get() {
      return this.get('next');
    }
  }], [{
    key: "withKey",
    value: function withKey(Type) {
      return (
        /*#__PURE__*/
        function (_Linkage) {
          _inherits(_class, _Linkage);

          function _class(registry, value) {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, registry, Type, value));
          }

          return _class;
        }(Linkage)
      );
    }
  }]);

  return Linkage;
}(Struct);
/**
 * @name LinkageResult
 * @description A Linkage keys/Values tuple
 */

export var LinkageResult =
/*#__PURE__*/
function (_Tuple) {
  _inherits(LinkageResult, _Tuple);

  function LinkageResult(registry, _ref, _ref2) {
    var _ref3 = _slicedToArray(_ref, 2),
        TypeKey = _ref3[0],
        keys = _ref3[1];

    var _ref4 = _slicedToArray(_ref2, 2),
        TypeValue = _ref4[0],
        values = _ref4[1];

    _classCallCheck(this, LinkageResult);

    return _possibleConstructorReturn(this, _getPrototypeOf(LinkageResult).call(this, registry, {
      Keys: Vec.with(TypeKey),
      Values: Vec.with(TypeValue)
    }, [keys, values]));
  }

  return LinkageResult;
}(Tuple);